/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { GlobalSecretsUpsertSpec } from '../model/globalSecretsUpsertSpec';
// @ts-ignore
import { UnifiedSecretInfo } from '../model/unifiedSecretInfo';
// @ts-ignore
import { VlrOrgSecretsUpsertSpec } from '../model/vlrOrgSecretsUpsertSpec';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class UnifiedSecretsOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Saves a global secret.
     * Saves a global secret.
     * @param globalSecretsUpsertSpec Specification to create/update global secret
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOrUpdateGlobalSecretOperator(globalSecretsUpsertSpec: GlobalSecretsUpsertSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public createOrUpdateGlobalSecretOperator(globalSecretsUpsertSpec: GlobalSecretsUpsertSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public createOrUpdateGlobalSecretOperator(globalSecretsUpsertSpec: GlobalSecretsUpsertSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public createOrUpdateGlobalSecretOperator(globalSecretsUpsertSpec: GlobalSecretsUpsertSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (globalSecretsUpsertSpec === null || globalSecretsUpsertSpec === undefined) {
            throw new Error('Required parameter globalSecretsUpsertSpec was null or undefined when calling createOrUpdateGlobalSecretOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/global-secrets`;
        return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: globalSecretsUpsertSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Saves a VLR Org secret
     * Saves a VLR Org secret
     * @param vlrOrgSecretsUpsertSpec Specification to create/update VLR org secret
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOrUpdateVlrOrgSecretOperator(vlrOrgSecretsUpsertSpec: VlrOrgSecretsUpsertSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public createOrUpdateVlrOrgSecretOperator(vlrOrgSecretsUpsertSpec: VlrOrgSecretsUpsertSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public createOrUpdateVlrOrgSecretOperator(vlrOrgSecretsUpsertSpec: VlrOrgSecretsUpsertSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public createOrUpdateVlrOrgSecretOperator(vlrOrgSecretsUpsertSpec: VlrOrgSecretsUpsertSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (vlrOrgSecretsUpsertSpec === null || vlrOrgSecretsUpsertSpec === undefined) {
            throw new Error('Required parameter vlrOrgSecretsUpsertSpec was null or undefined when calling createOrUpdateVlrOrgSecretOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/vlr-org-secrets`;
        return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: vlrOrgSecretsUpsertSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes a global secret.
     * @param secretCategory Secret category
     * @param cloudProvider Cloud provider
     * @param vmcOrgId VMC organization identifier in optional filter
     * @param cbPopId Carbon black pop Id
     * @param orgKey Carbon black org key
     * @param username Carbon Black parent org login username
     * @param cid CrowdStrike CID
     * @param apiKeyId API key Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteGlobalSecretOperator(secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', cloudProvider?: 'AWS' | 'GCP', vmcOrgId?: string, cbPopId?: string, orgKey?: string, username?: string, cid?: string, apiKeyId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public deleteGlobalSecretOperator(secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', cloudProvider?: 'AWS' | 'GCP', vmcOrgId?: string, cbPopId?: string, orgKey?: string, username?: string, cid?: string, apiKeyId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public deleteGlobalSecretOperator(secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', cloudProvider?: 'AWS' | 'GCP', vmcOrgId?: string, cbPopId?: string, orgKey?: string, username?: string, cid?: string, apiKeyId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public deleteGlobalSecretOperator(secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', cloudProvider?: 'AWS' | 'GCP', vmcOrgId?: string, cbPopId?: string, orgKey?: string, username?: string, cid?: string, apiKeyId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (secretCategory === null || secretCategory === undefined) {
            throw new Error('Required parameter secretCategory was null or undefined when calling deleteGlobalSecretOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProvider, 'cloud-provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>secretCategory, 'secret-category');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vmcOrgId, 'vmc-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cbPopId, 'cb-pop-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgKey, 'org-key');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>username, 'username');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cid, 'cid');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>apiKeyId, 'api-key-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/global-secrets/global-secret`;
        return this.httpClient.request<string>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes a VLR Org secret.
     * @param cloudProvider Cloud provider
     * @param vlrOrgId VLR Org Id
     * @param cloudAccountType Cloud account type
     * @param cloudProviderRegion Cloud provider region
     * @param secretCategory Secret category
     * @param serviceType Service Type
     * @param deploymentId Deployment identifier
     * @param vmcOrgId VMC organization identifier in optional filter
     * @param orgKey Carbon black org key
     * @param cid CrowdStrike CID
     * @param apiKeyId API key Id
     * @param refId Ref Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteVlrOrgSecretOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudAccountType: 'SHADOW' | 'ADMIN', cloudProviderRegion: string, secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', serviceType: 'VCDR' | 'VMCFS', deploymentId?: string, vmcOrgId?: string, orgKey?: string, cid?: string, apiKeyId?: string, refId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public deleteVlrOrgSecretOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudAccountType: 'SHADOW' | 'ADMIN', cloudProviderRegion: string, secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', serviceType: 'VCDR' | 'VMCFS', deploymentId?: string, vmcOrgId?: string, orgKey?: string, cid?: string, apiKeyId?: string, refId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public deleteVlrOrgSecretOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudAccountType: 'SHADOW' | 'ADMIN', cloudProviderRegion: string, secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', serviceType: 'VCDR' | 'VMCFS', deploymentId?: string, vmcOrgId?: string, orgKey?: string, cid?: string, apiKeyId?: string, refId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public deleteVlrOrgSecretOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudAccountType: 'SHADOW' | 'ADMIN', cloudProviderRegion: string, secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', serviceType: 'VCDR' | 'VMCFS', deploymentId?: string, vmcOrgId?: string, orgKey?: string, cid?: string, apiKeyId?: string, refId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (cloudProvider === null || cloudProvider === undefined) {
            throw new Error('Required parameter cloudProvider was null or undefined when calling deleteVlrOrgSecretOperator.');
        }
        if (vlrOrgId === null || vlrOrgId === undefined) {
            throw new Error('Required parameter vlrOrgId was null or undefined when calling deleteVlrOrgSecretOperator.');
        }
        if (cloudAccountType === null || cloudAccountType === undefined) {
            throw new Error('Required parameter cloudAccountType was null or undefined when calling deleteVlrOrgSecretOperator.');
        }
        if (cloudProviderRegion === null || cloudProviderRegion === undefined) {
            throw new Error('Required parameter cloudProviderRegion was null or undefined when calling deleteVlrOrgSecretOperator.');
        }
        if (secretCategory === null || secretCategory === undefined) {
            throw new Error('Required parameter secretCategory was null or undefined when calling deleteVlrOrgSecretOperator.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling deleteVlrOrgSecretOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProvider, 'cloud-provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vlrOrgId, 'vlr-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudAccountType, 'cloud-account-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentId, 'deployment-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProviderRegion, 'cloud-provider-region');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>secretCategory, 'secret-category');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vmcOrgId, 'vmc-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgKey, 'org-key');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cid, 'cid');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>apiKeyId, 'api-key-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>refId, 'ref-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/vlr-org-secrets/vlr-org-secret`;
        return this.httpClient.request<string>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets Admin account secret locations by given params and secret location starting given string
     * @param cloudProvider Cloud provider
     * @param secretLocationStartsWith Secret location prefix
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAdminAccountSecretLocationsOperator(cloudProvider: 'AWS' | 'GCP', secretLocationStartsWith?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<string>>;
    public getAdminAccountSecretLocationsOperator(cloudProvider: 'AWS' | 'GCP', secretLocationStartsWith?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<string>>>;
    public getAdminAccountSecretLocationsOperator(cloudProvider: 'AWS' | 'GCP', secretLocationStartsWith?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<string>>>;
    public getAdminAccountSecretLocationsOperator(cloudProvider: 'AWS' | 'GCP', secretLocationStartsWith?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (cloudProvider === null || cloudProvider === undefined) {
            throw new Error('Required parameter cloudProvider was null or undefined when calling getAdminAccountSecretLocationsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProvider, 'cloud-provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>secretLocationStartsWith, 'secret_location_starts_with');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/admin-account-secrets`;
        return this.httpClient.request<Array<string>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a global secret.
     * @param secretCategory Secret category
     * @param cloudProvider Cloud provider
     * @param vmcOrgId VMC organization identifier in optional filter
     * @param cbPopId Carbon black pop Id
     * @param orgKey Carbon black org key
     * @param username Carbon Black parent org login username
     * @param cid CrowdStrike CID
     * @param apiKeyId API key Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGlobalSecretOperator(secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', cloudProvider?: 'AWS' | 'GCP', vmcOrgId?: string, cbPopId?: string, orgKey?: string, username?: string, cid?: string, apiKeyId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<UnifiedSecretInfo>;
    public getGlobalSecretOperator(secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', cloudProvider?: 'AWS' | 'GCP', vmcOrgId?: string, cbPopId?: string, orgKey?: string, username?: string, cid?: string, apiKeyId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<UnifiedSecretInfo>>;
    public getGlobalSecretOperator(secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', cloudProvider?: 'AWS' | 'GCP', vmcOrgId?: string, cbPopId?: string, orgKey?: string, username?: string, cid?: string, apiKeyId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<UnifiedSecretInfo>>;
    public getGlobalSecretOperator(secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', cloudProvider?: 'AWS' | 'GCP', vmcOrgId?: string, cbPopId?: string, orgKey?: string, username?: string, cid?: string, apiKeyId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (secretCategory === null || secretCategory === undefined) {
            throw new Error('Required parameter secretCategory was null or undefined when calling getGlobalSecretOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProvider, 'cloud-provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>secretCategory, 'secret-category');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vmcOrgId, 'vmc-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cbPopId, 'cb-pop-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgKey, 'org-key');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>username, 'username');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cid, 'cid');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>apiKeyId, 'api-key-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/global-secrets/global-secret`;
        return this.httpClient.request<UnifiedSecretInfo>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Query global secrets.
     * @param secretCategory Secret category
     * @param cloudProvider Cloud provider
     * @param vmcOrgId VMC organization identifier in optional filter
     * @param cbPopId Carbon black pop Id
     * @param orgKey Carbon black org key
     * @param username Carbon Black parent org login username
     * @param cid CrowdStrike CID
     * @param apiKeyId API key Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGlobalSecretsOperator(secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', cloudProvider?: 'AWS' | 'GCP', vmcOrgId?: string, cbPopId?: string, orgKey?: string, username?: string, cid?: string, apiKeyId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<UnifiedSecretInfo>>;
    public getGlobalSecretsOperator(secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', cloudProvider?: 'AWS' | 'GCP', vmcOrgId?: string, cbPopId?: string, orgKey?: string, username?: string, cid?: string, apiKeyId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<UnifiedSecretInfo>>>;
    public getGlobalSecretsOperator(secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', cloudProvider?: 'AWS' | 'GCP', vmcOrgId?: string, cbPopId?: string, orgKey?: string, username?: string, cid?: string, apiKeyId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<UnifiedSecretInfo>>>;
    public getGlobalSecretsOperator(secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', cloudProvider?: 'AWS' | 'GCP', vmcOrgId?: string, cbPopId?: string, orgKey?: string, username?: string, cid?: string, apiKeyId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (secretCategory === null || secretCategory === undefined) {
            throw new Error('Required parameter secretCategory was null or undefined when calling getGlobalSecretsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProvider, 'cloud-provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>secretCategory, 'secret-category');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vmcOrgId, 'vmc-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cbPopId, 'cb-pop-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgKey, 'org-key');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>username, 'username');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cid, 'cid');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>apiKeyId, 'api-key-id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/global-secrets`;
        return this.httpClient.request<Array<UnifiedSecretInfo>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets Shadow account secret locations by given params and secret location starting given string
     * @param cloudProvider Cloud provider
     * @param vlrOrgId VLR Org Id
     * @param cloudProviderRegion Cloud provider region
     * @param secretLocationStartsWith Secret location prefix
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getShadowAccountSecretLocationsOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudProviderRegion: string, secretLocationStartsWith?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<string>>;
    public getShadowAccountSecretLocationsOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudProviderRegion: string, secretLocationStartsWith?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<string>>>;
    public getShadowAccountSecretLocationsOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudProviderRegion: string, secretLocationStartsWith?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<string>>>;
    public getShadowAccountSecretLocationsOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudProviderRegion: string, secretLocationStartsWith?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (cloudProvider === null || cloudProvider === undefined) {
            throw new Error('Required parameter cloudProvider was null or undefined when calling getShadowAccountSecretLocationsOperator.');
        }
        if (vlrOrgId === null || vlrOrgId === undefined) {
            throw new Error('Required parameter vlrOrgId was null or undefined when calling getShadowAccountSecretLocationsOperator.');
        }
        if (cloudProviderRegion === null || cloudProviderRegion === undefined) {
            throw new Error('Required parameter cloudProviderRegion was null or undefined when calling getShadowAccountSecretLocationsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProvider, 'cloud-provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vlrOrgId, 'vlr-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProviderRegion, 'cloud-provider-region');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>secretLocationStartsWith, 'secret_location_starts_with');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/shadow-account-secrets`;
        return this.httpClient.request<Array<string>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a VLR Org secret.
     * @param cloudProvider Cloud provider
     * @param vlrOrgId VLR Org Id
     * @param cloudAccountType Cloud account type
     * @param cloudProviderRegion Cloud provider region
     * @param secretCategory Secret category
     * @param serviceType Service Type
     * @param deploymentId Deployment identifier
     * @param vmcOrgId VMC organization identifier in optional filter
     * @param orgKey Carbon black org key
     * @param cid CrowdStrike CID
     * @param apiKeyId API key Id
     * @param refId Ref Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVlrOrgSecretOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudAccountType: 'SHADOW' | 'ADMIN', cloudProviderRegion: string, secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', serviceType: 'VCDR' | 'VMCFS', deploymentId?: string, vmcOrgId?: string, orgKey?: string, cid?: string, apiKeyId?: string, refId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<UnifiedSecretInfo>;
    public getVlrOrgSecretOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudAccountType: 'SHADOW' | 'ADMIN', cloudProviderRegion: string, secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', serviceType: 'VCDR' | 'VMCFS', deploymentId?: string, vmcOrgId?: string, orgKey?: string, cid?: string, apiKeyId?: string, refId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<UnifiedSecretInfo>>;
    public getVlrOrgSecretOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudAccountType: 'SHADOW' | 'ADMIN', cloudProviderRegion: string, secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', serviceType: 'VCDR' | 'VMCFS', deploymentId?: string, vmcOrgId?: string, orgKey?: string, cid?: string, apiKeyId?: string, refId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<UnifiedSecretInfo>>;
    public getVlrOrgSecretOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudAccountType: 'SHADOW' | 'ADMIN', cloudProviderRegion: string, secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', serviceType: 'VCDR' | 'VMCFS', deploymentId?: string, vmcOrgId?: string, orgKey?: string, cid?: string, apiKeyId?: string, refId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (cloudProvider === null || cloudProvider === undefined) {
            throw new Error('Required parameter cloudProvider was null or undefined when calling getVlrOrgSecretOperator.');
        }
        if (vlrOrgId === null || vlrOrgId === undefined) {
            throw new Error('Required parameter vlrOrgId was null or undefined when calling getVlrOrgSecretOperator.');
        }
        if (cloudAccountType === null || cloudAccountType === undefined) {
            throw new Error('Required parameter cloudAccountType was null or undefined when calling getVlrOrgSecretOperator.');
        }
        if (cloudProviderRegion === null || cloudProviderRegion === undefined) {
            throw new Error('Required parameter cloudProviderRegion was null or undefined when calling getVlrOrgSecretOperator.');
        }
        if (secretCategory === null || secretCategory === undefined) {
            throw new Error('Required parameter secretCategory was null or undefined when calling getVlrOrgSecretOperator.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling getVlrOrgSecretOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProvider, 'cloud-provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vlrOrgId, 'vlr-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudAccountType, 'cloud-account-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentId, 'deployment-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProviderRegion, 'cloud-provider-region');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>secretCategory, 'secret-category');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vmcOrgId, 'vmc-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgKey, 'org-key');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cid, 'cid');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>apiKeyId, 'api-key-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>refId, 'ref-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/vlr-org-secrets/vlr-org-secret`;
        return this.httpClient.request<UnifiedSecretInfo>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Query VLR Org secrets.
     * @param cloudProvider Cloud provider
     * @param vlrOrgId VLR Org Id
     * @param cloudAccountType Cloud account type
     * @param cloudProviderRegion Cloud provider region
     * @param secretCategory Secret category
     * @param serviceType Service Type
     * @param deploymentId Deployment identifier
     * @param vmcOrgId VMC organization identifier in optional filter
     * @param orgKey Carbon black org key
     * @param cid CrowdStrike CID
     * @param apiKeyId API key Id
     * @param refId Ref Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVlrOrgSecretsOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudAccountType: 'SHADOW' | 'ADMIN', cloudProviderRegion: string, secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', serviceType: 'VCDR' | 'VMCFS', deploymentId?: string, vmcOrgId?: string, orgKey?: string, cid?: string, apiKeyId?: string, refId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<UnifiedSecretInfo>>;
    public getVlrOrgSecretsOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudAccountType: 'SHADOW' | 'ADMIN', cloudProviderRegion: string, secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', serviceType: 'VCDR' | 'VMCFS', deploymentId?: string, vmcOrgId?: string, orgKey?: string, cid?: string, apiKeyId?: string, refId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<UnifiedSecretInfo>>>;
    public getVlrOrgSecretsOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudAccountType: 'SHADOW' | 'ADMIN', cloudProviderRegion: string, secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', serviceType: 'VCDR' | 'VMCFS', deploymentId?: string, vmcOrgId?: string, orgKey?: string, cid?: string, apiKeyId?: string, refId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<UnifiedSecretInfo>>>;
    public getVlrOrgSecretsOperator(cloudProvider: 'AWS' | 'GCP', vlrOrgId: string, cloudAccountType: 'SHADOW' | 'ADMIN', cloudProviderRegion: string, secretCategory: 'VLCR_OAUTH_APP' | 'SDDC_VMC_OAUTH_APP' | 'VMCFS_SDDC_VMC_OAUTH_APP' | 'CARBON_BLACK_ORG_CREDENTIALS' | 'CARBON_BLACK_API_KEY' | 'BYOL_CARBON_BLACK_API_KEY' | 'CROWDSTRIKE_API_KEY' | 'VLSR_CLOUD_PAIRING' | 'VCDS_OAUTH_APP' | 'IRR_GATEWAY_CERT', serviceType: 'VCDR' | 'VMCFS', deploymentId?: string, vmcOrgId?: string, orgKey?: string, cid?: string, apiKeyId?: string, refId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (cloudProvider === null || cloudProvider === undefined) {
            throw new Error('Required parameter cloudProvider was null or undefined when calling getVlrOrgSecretsOperator.');
        }
        if (vlrOrgId === null || vlrOrgId === undefined) {
            throw new Error('Required parameter vlrOrgId was null or undefined when calling getVlrOrgSecretsOperator.');
        }
        if (cloudAccountType === null || cloudAccountType === undefined) {
            throw new Error('Required parameter cloudAccountType was null or undefined when calling getVlrOrgSecretsOperator.');
        }
        if (cloudProviderRegion === null || cloudProviderRegion === undefined) {
            throw new Error('Required parameter cloudProviderRegion was null or undefined when calling getVlrOrgSecretsOperator.');
        }
        if (secretCategory === null || secretCategory === undefined) {
            throw new Error('Required parameter secretCategory was null or undefined when calling getVlrOrgSecretsOperator.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling getVlrOrgSecretsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProvider, 'cloud-provider');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vlrOrgId, 'vlr-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudAccountType, 'cloud-account-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentId, 'deployment-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cloudProviderRegion, 'cloud-provider-region');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>secretCategory, 'secret-category');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vmcOrgId, 'vmc-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgKey, 'org-key');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cid, 'cid');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>apiKeyId, 'api-key-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>refId, 'ref-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/vlr-org-secrets`;
        return this.httpClient.request<Array<UnifiedSecretInfo>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
